import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Load Babel standalone for live JSX eval
const script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/babel-standalone/7.23.2/babel.min.js';
script.onload = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
};
document.head.appendChild(script);
